import { DISPLAY_LANG } from '../../config';
import { useContext } from 'react';
import { CurrencyContext } from '../../contexts/CurrencyContext';
import { addToCartText, hostingBillingTypeText } from '../../api/global';
import { useNavigate } from 'react-router-dom';
import './Plans.css';

export default function Plans({ plans, billingType }) {
    const { selectedCurrency } = useContext(CurrencyContext);
    const navigate = useNavigate();

    const getHostingHandler = (plan) => {
        const isLogin = localStorage.getItem('token');
        sessionStorage.setItem('SELECTED_HOSTING_PLAN_NAME', plan.name);

        if (isLogin) {
            navigate(`/hosting/${plan.name}?billing=${billingType}`);
            sessionStorage.setItem('SELECTED_HOSTING_PLAN', JSON.stringify({ ...plan, billingType }));
        } else {
            navigate('/user/login');
        }
    };

    return (
        <div className="plans flex-center">
            {
                plans.map((plan, idx) => {
                    if (plan.name === 'Free') {
                        return null;
                    }

                    return (
                        <div key={idx} className={`plan ${plan.is_highlighted ? "active" : ""}`}>
                            <div>
                                <h3>{plan.name}</h3>
                                <p className='plan-descr'>{plan.description[DISPLAY_LANG]}</p>

                                <div className="includes">
                                    {
                                        plan.characteristicslist.map((feature, i) => (
                                            <p
                                                key={i}
                                                className={'flex-center'}
                                            >
                                                {
                                                    plan.is_highlighted ? (
                                                        <img src="/images/hosting_plans/check-white.svg" alt="check" />
                                                    ) : (
                                                        <img src="/images/hosting_plans/check-blue.svg" alt="check" />
                                                    )
                                                }

                                                {feature.title}
                                            </p>
                                        ))
                                    }
                                </div>

                                <p className="price">
                                    {
                                        billingType === 'monthly' ? (
                                            <>
                                                {selectedCurrency.symbol === '$' && selectedCurrency.symbol + ' '}
                                                {plan.prices.monthly[selectedCurrency.title]}
                                                {selectedCurrency.symbol !== '$' && ' ' + selectedCurrency.symbol}
                                                <span> / {hostingBillingTypeText[DISPLAY_LANG].split('/')[0]}</span>
                                            </>
                                        ) : (
                                            <>
                                                {selectedCurrency.symbol === '$' && selectedCurrency.symbol + ' '}
                                                {Math.ceil(plan.prices.yearly[selectedCurrency.title] / 12).toFixed(2)}
                                                {selectedCurrency.symbol !== '$' && ' ' + selectedCurrency.symbol}
                                                <span> / {hostingBillingTypeText[DISPLAY_LANG].split('/')[0]}</span>

                                                {/* yearli price poqr nerqevum */}
                                                <div style={{ fontSize: '12px', color: '#999', marginTop: '10px' }}>
                                                    {selectedCurrency.symbol === '$' && selectedCurrency.symbol + ' '}
                                                    {plan.prices.yearly[selectedCurrency.title] + ' '}

                                                    <span style={{ fontSize: '12px' }}>
                                                    / {hostingBillingTypeText[DISPLAY_LANG].split('/')[1]}
                                                    </span>
                                                </div>
                                            </>
                                        )
                                    }
                                </p>
                            </div>

                            <button href="#" className="btn" onClick={() => getHostingHandler(plan)}>
                                {addToCartText[DISPLAY_LANG]}
                            </button>
                        </div>
                    )
                })
            }
        </div>
    );
}